import {http} from '@/http/index.js';

async function getProfile(girlId) {
  return http.get(`/girls/${girlId}`).then((response) => response.data.data);
}

export {getProfile};
